import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", (event) => {

    /**
     * Slides to the slide with the 'data-slider-start' attribute.
     *
     * @param {import('swiper').Swiper} swiperInstance - The Swiper instance.
     */
    function slideToDataAttr(swiperInstance) {
        const container = $(swiperInstance.el)[0];
        const targetEl = container?.querySelector('[data-start-here]');

        if (!targetEl) return;

        const slide = targetEl.closest('.swiper-slide');

        if (slide) {
            let slideIndex = slide.getAttribute('data-swiper-slide-index') ?? Array.from(swiperInstance.slides).indexOf(slide);

            swiperInstance.slideTo(parseInt(slideIndex), 0);
        }
    }

   
    const statusSwiper = new Swiper('.js-swiper-status-slider', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true, 
        mousewheel: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        centeredSlides: false,
    });

    if(statusSwiper) {
        slideToDataAttr(statusSwiper);
    }
    
});